/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from "../shared/Globals";
import { qreq } from "../shared/qrequest";
import BaseCom from "./BaseCom";
import DatePicker from "./DatePicker";
import FormInput from "./FormInput";
import Icon from "./Icon";
import L from "./Lang";

export default class ProductSelectW extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            productList: [],
            selectedProducts: [],
            modCodes: []
        };
    }

    // lotnumber, catalogCode, expirationDate, quantity

    async componentDidMount() {
        let productList = await this.loadProducts();
        if (productList)
            this.setupCurrentValues(productList);
        await this.fillListAsync('/api/modcode/list', 'modCodes', true);
    }

    componentDidUpdate(prevProps) {
        if (this.props.currentValues !== prevProps.currentValues) {
            //this.setupCurrentValues();
        }
    }

    loadProducts = async () => {
        try {
            let j = await qreq.postAsync('/api/product/list', {});
            if (j.list) {
                this.setState({ productList: j.list });
                j.list.forEach(i => {
                    i._name = i.manufacturer + ' ' + i.productName + ' ' + i.productSize;
                });
                return j.list;
            }
            else
                this.alert(<L>Failed to pull product list.</L>);
        }
        catch (e) {
            this.unkownErrorCallback();
        }
    }

    setupCurrentValues = (productList) => {
        if (this.props.currentValues) {
            if (!productList)
                productList = [...this.state.productList];

            let selectedProducts = [];
            this.props.currentValues.forEach(i => {
                let find = productList.find(x => x.id === i.id);
                if (find) {
                    let v = { ...find, ...i };
                    v._name = find.manufacturer + ' ' + find.productName + '_' + find.productSize;
                    selectedProducts.push(v);
                }
            })

            this.setState({ selectedProducts });
        }
    }

    toggle = (e, p, idx) => {
        let productList = [...this.state.productList];
        productList[idx].selected = e.target.checked;
        productList[idx].expirationDate = new Date();
        this.setState({ productList });
        this.propagate();
    }

    propagate = (selectedProducts) => {
        if (!selectedProducts)
            selectedProducts = this.state.selectedProducts;
        this.props.onChange?.(selectedProducts);
    }

    setProduct = (i, idx, productID) => {
        let product = this.state.productList.find(x => x.id === parseInt(productID));
        let selectedProducts = [...this.state.selectedProducts];
        var v = { ...product, expirationDate: new Date(), lotNumber: '' };
        selectedProducts[idx] = v;
        this.setState({ selectedProducts });
        this.propagate(selectedProducts);
    }

    setProductLotNumber = (i, idx, v) => {
        let selectedProducts = [...this.state.selectedProducts];
        selectedProducts[idx].lotNumber = v;
        this.setState({ selectedProducts });
        this.propagate(selectedProducts);
    }

    setProductUnits = (i, idx, v) => {
        let selectedProducts = [...this.state.selectedProducts];
        selectedProducts[idx].units = parseInt(v);
        this.setState({ selectedProducts });
        this.propagate(selectedProducts);
    }

    setProductExpirationDate = (i, idx, v) => {
        let selectedProducts = [...this.state.selectedProducts];
        selectedProducts[idx].expirationDate = v;
        this.setState({ selectedProducts });
        this.propagate(selectedProducts);
    }

    addProduct = () => {
        var selectedProducts = [...this.state.selectedProducts];
        selectedProducts.push({
            expirationDate: Globals.toISOLocalDateString(new Date()) + " 00:00:00",
            units: 0
        });
        this.setState({ selectedProducts });
        this.propagate(selectedProducts);
    }

    removeProduct = (i, idx) => {
        var selectedProducts = [...this.state.selectedProducts];
        selectedProducts.splice(idx, 1);
        this.setState({ selectedProducts });
        this.propagate(selectedProducts);
    }

    addModCode = (e, i) => {
        let find = i.modifiers?.find(j => j.id === parseInt(e.target.value));
        if (find) {
            i.add = false;
            this.setState({ selectedProducts: [...this.state.selectedProducts] });
            setTimeout(() => this.propagate(), 100);
            return; // already added
        }
        let mod = this.state.modCodes.find(j => j.id === parseInt(e.target.value));
        if (mod) {
            i.modifiers = i.modifiers ?? [];
            i.modifiers.push(mod);
            i.add = false;
        }
        this.setState({ selectedProducts: [...this.state.selectedProducts] });
        setTimeout(() => this.propagate(), 100);
    }

    removeModCode = (i, j) => {
        i.modifiers = i.modifiers.filter(a => a.id !== j.id);
        this.props.onChange?.(this.state.currentValues);
    }

    render() {
        return <div>
            <table className="table">
                <tbody>
                    {this.state.selectedProducts?.map((i, idx) => <tr key={idx}>
                        <td>
                            <FormInput model={i} name="id" label="Product" type="select" labelAsPlaceholder optionsName="_name"
                                options={this.state.productList} required onChange={(v) => this.setProduct(i, idx, v)} disabled={this.props.disabled} />
                        </td>
                        <td>
                            <input type="text" className="form-control"
                                onChange={(e) => this.setProductLotNumber(i, idx, e.target.value)}
                                value={i.lotNumber}
                                placeholder="Lot Number"
                                required
                                disabled={!i.id || this.props.disabled}
                            />
                        </td>
                        <td>
                            <input type="number" className="form-control"
                                onChange={(e) => this.setProductUnits(i, idx, e.target.value)}
                                value={i.units}
                                placeholder="Units"
                                required
                                disabled={!i.id || this.props.disabled}
                            />
                        </td>
                        <td>
                            {i.id && <DatePicker
                                initialDate={i.expirationDate}
                                onChange={(e) => this.setProductExpirationDate(i, idx, e)}
                                disabled={this.props.disabled}
                            />}
                        </td>
                        <td>
                            <span>
                                {i.modifiers?.length === 0 && !i.add && <span className="text-muted">None</span>}
                                {!this.props.disabled && i.modifiers?.map((j, jdx) => (
                                    <span key={jdx} className="badge bg-secondary me-1 mb-1 no-select" title={j.description} data-tooltip-content={j.description}>
                                        {j.code} <Icon icon="faTimes" role="button" onClick={() => this.removeModCode(i, j)} />
                                    </span>
                                ))}
                            </span>
                            <div className="input-group">
                                <select className="form-select" onChange={(e) => this.addModCode(e, i)} disabled={this.props.disabled}>
                                    <option value="">Select Modifier</option>
                                    {this.state.modCodes.map((j, jdx) => !i.modifiers?.find(a => a.id === j.id)
                                        && <option key={jdx} value={j.id}>{j.code} - {j.description}</option>)}
                                </select>
                            </div>
                        </td>
                        <td>
                            {!this.props.disabled && <button type="button" className="btn btn-danger" onClick={() => this.removeProduct(i, idx)}>
                                <Icon icon="faTrash" />
                            </button>}
                        </td>
                    </tr>)}
                </tbody>
            </table>
            {!this.props.disabled && <div className="mt-3">
                <button type="button" className="btn btn-primary" onClick={this.addProduct}>
                    <Icon icon="faPlus" /> <L>Add Product</L>
                </button>
            </div>}
        </div>;
    }
}